import { useState } from "react";
import {
  AppBar,
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Container,
  Grid,
  IconButton,
  Toolbar,
  Typography,
  Link,
  Button
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import "./App.css";
import { Email, GitHub, Twitter } from "@material-ui/icons";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import ContactForm from './ContactForm';
import myLogo from './assets/app_store_download.svg';
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  footer: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    textAlign: "center",
  },
  button: {
    margin: theme.spacing(1),
    width: 48,
    height: 48,
  },
  title: {
    flexGrow: 1,
  },
  card: {
    maxWidth: 345,
    margin: theme.spacing(2),
    height: 450,
  },
}));

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/" element={<Home />} />
        <Route path="/esperto-app" element={<EspertoApp />} />
      </Routes>
    </Router>
  )
}

const EspertoApp = () => {
  const imgURL = "https://fastly.picsum.photos/id/568/3000/1500.jpg?hmac=slxzFQCZUu0nVN49VhHB1CW33xUSB3K158PWHssdzZ0"
  const appStoreUrl = "https://apps.apple.com/us/app/esperto/id6446505405?platform=iphone"

  const handleClick = () => {
    // alert("Clicked")
    window.location.href = appStoreUrl;
  }

  return (
    <Box>
      <Box
        style={{
          backgroundImage: `url(${imgURL})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          height: '50vh',
        }}
      >
        <Typography align="center" variant="h1" component="h1" style={{ color: 'white', paddingTop: '30vh' }}>
          Esperto
        </Typography>
      </Box>
      <Box>
        {/* </div> */}
        <section style={{ padding: '2rem' }}>
          <Typography variant="h2" component="h2">Why use Esperto?</Typography>
          <Typography variant="h6" component="h6">
            Esperto is a lightweight mobile app that makes shopping for groceries easy: you can favorite groecery items to your lists, and rececive notifications when they are on sale.
          </Typography>
          <Typography variant="h2" component="h2">Download</Typography>
          <div>
            <img onClick={handleClick} src={myLogo} alt="SVG logo image"/>
          </div>
        </section>
        <section style={{ padding: '2rem' }}>
        </section>
      </Box>

    </Box>
  )
}


const Home = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const [projects, setProjects] = useState([
    {
      id: 1,
      title: "Research Publications",
      image: "https://images.unsplash.com/photo-1676688125315-711073646a73?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8fHx8fHx8MTY3ODkyNDE3NA&ixlib=rb-4.0.3&q=80&w=1080",
      description:
        "My research publications",
      url: "https://haochenuw.github.io",
    },
    {
      id: 2,
      title: "playcoup.live",
      image: "https://images.unsplash.com/photo-1677856216846-596a3d6d869e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8fHx8fHx8MTY3ODkyNDIxOQ&ixlib=rb-4.0.3&q=80&w=1080",
      description:
        "A website to play the board game \"coup\" online, written based on React and socket.io.",
      url: "https://playcoup.live",
    },
    {
      id: 3,
      title: "Live Demo of the Signal protocol",
      image: "https://images.unsplash.com/photo-1678141100437-5fb926554b6f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8fHx8fHx8MTY3ODkyNDI1Mw&ixlib=rb-4.0.3&q=80&w=1080",
      description:
        "An interactive website that reveals the internals of the \" signal\" end to end encrypted messaging protocol.",
      url: "https://ec2-54-201-48-228.us-west-2.compute.amazonaws.com",
    },
    {
      id: 4,
      title: "Esperto App",
      image: "https://fastly.picsum.photos/id/218/200/200.jpg?hmac=pIx-HTJBJRheNaHmhgqsQRX8JbTGvag_zic9NTNWFJU",
      description:
        "An iOS app that allows users to save grocery items and get notified when they are on sale.",
      url: "",
    },
  ]);
  return (
    <Box>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            Hao Chen
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="md">
        <Box my={4}>
          <Typography variant="h4" component="h1" gutterBottom>
            About Me
          </Typography>
          <Typography variant="body1" component="p" gutterBottom>
            I am a cryptographer and software engineer. As a cryptographer, I authored 20+ papers on homomorphic encryption and secure multiparty computation, which appeared on top-tier venues such as ACM CCS, IACR Eurocrypt and USENIX Security.

            As a software engineer, I have been working on shipping and scaling privacy enhancing technologies.

            In my spare time, I enjoy building websites and mobile apps.
          </Typography>
        </Box>
        <Box my={4}>
          <Typography variant="h4" component="h2" gutterBottom>
            My Projects
          </Typography>
          <Grid container spacing={3}>
            {projects.map((project) => (
              <Grid item xs={12} sm={6} md={4} key={project.id}>
                <Card className={classes.card} onClick={
                  ()=>{if (project.url === "") {navigate(`/esperto-app`)}}
                }>
                  <CardActionArea href={project.url} target="_blank">
                    <CardMedia
                      component="img"
                      alt={project.title}
                      height="200"
                      image={project.image}
                      title={project.title}
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                        {project.title}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" component="p">
                        {project.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
      <Box>
        {/* Bio section */}
        {/* Projects section */}
        {/* Contact me section */}
        <Box className={classes.footer}>
          <Grid container justify="center">
            <Grid item>
              <IconButton
                aria-label="Email"
                className={classes.button}
                href="mailto:sxxach@gmail.com"
              >
                <Email />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton
                aria-label="GitHub"
                className={classes.button}
                href="https://github.com/haochenuw"
                target="_blank"
              >
                <GitHub />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton
                aria-label="Twitter"
                className={classes.button}
                href="https://twitter.com/haochenCrypto"
                target="_blank"
              >
                <Twitter />
              </IconButton>
            </Grid>
          </Grid>
          <Typography variant="body2">
            Contact me via{" "}
            <Link href="mailto:sxxach@gmail.com" color="inherit">
              email
            </Link>
            ,{" "}
            <Link href="https://github.com/haochenuw" color="inherit">
              Github
            </Link>
            , or{" "}
            <Link href="https://twitter.com/haochenCrypto" color="inherit">
              Twitter
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default App;
